import React from 'react';
import { Dialog } from '@mui/material';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PathwordStore } from '../PathwordStore';
import '../../shared/RevealConfirmationDialog/RevealConfirmationDialog.less';

const AlmostThereDialog = () => {
  const isOpen = PathwordStore.useState(s => s.almostThereIsOpen);

  const onClose = () => {
    PathwordStore.update(s => {
      s.almostThereIsOpen = false;
    });
  };

  // This dialog cannot be closed by clicking the backdrop,
  // because allowing that causes it to close instantly on mobile
  // because the final touch keyboard input is still "active" and insta-closes it.
  return (
    <Dialog open={isOpen}>
      <div className="revealConfirmationDialogContent">
        <IconButton className="closeButton" onClick={onClose}>
          <CloseIcon/>
        </IconButton>
        <div className="aboutBody">
          You've filled in the grid, but at least one horizontal row does not spell a word. Keep trying!
        </div>
      </div>
    </Dialog>
  );
};

export default AlmostThereDialog;